// extracted by mini-css-extract-plugin
module.exports = {"container":"tabButtons_container__1bDSG","button":"tabButtons_button__2G319","active":"tabButtons_active__1GrJB"};